import React from 'react';
import {
    Page,
    Card,
    ResourceItem,
    ResourceList,
    TextStyle,
    Badge,
    Filters,
    Tabs,
    Stack,
    Layout,
} from '@shopify/polaris';
import { useState, useEffect, useCallback } from 'react';
import { useHistory } from "react-router-dom";
import { AppSettings } from '../../common/AppSettings';
import { Helmet } from 'react-helmet';
import Cookies from "js-cookie";

function isEmpty(value) {
    if (Array.isArray(value)) {
        return value.length === 0;
    } else {
        return value === '' || value == null;
    }
}

function disambiguateLabel(key, value) {
    switch (key) {
        case 'operationFilter':
            return `Operation contains ${value}`;
        default:
            return value;
    }
}

function OperationsIndex() {

    const history = useHistory();
    const [sortValue, setSortValue] = useState('DATE_MODIFIED_DESC');
    const [operationFilterValue, setOperationFilterValue] = useState(null);
    const [queryValueValue, setQueryValueValue] = useState(null);
    const [operationsValue, setOperationsValue] = useState([]);
    const [selected, setSelected] = useState(0);
    const handleTabChange = useCallback(
        (selectedTabIndex) => setSelected(selectedTabIndex),
        [],
    );

    let onlyWithAutomations = selected === 3;
    let onlyProduct = selected === 1;
    let onlyCustomer = selected === 2;
    let items = operationsValue
        .filter(operation => queryValueValue == null || operation.description.toUpperCase().includes(queryValueValue.toUpperCase()))
        .filter(operation => !onlyWithAutomations || (operation.hasAutomation && onlyWithAutomations))
        .filter(operation => !onlyCustomer || (operation.type === "Customer" && onlyCustomer))
        .filter(operation => !onlyProduct || (operation.type === "Product" && onlyProduct))
        .map((item, index) => {
            return {
                id: item.id,
                name: item.name,
                url: null,
                description: item.description,
                created: new Date(item.dateCreated),
                status: item.status,
                type: item.type,
                operationType: item.operationType,
            }
        }).sort((a, b) => sortValue === 'DATE_MODIFIED_DESC' ? b.created - a.created : a.created - b.created);

    useEffect(() => {

        fetch(`${AppSettings.ApiHost}/api/operations/latest`, {
            method: 'get',
            headers: new Headers({
                'Authorization': 'Bearer ' + Cookies.get("__genie")
            })
        })
            .then(response => response.json())
            .then(data => setOperationsValue(data));
    }, []);

    const filterControl = getFilterControl();

    const tabs = [
        {
            id: 'all-operations',
            content: 'All',
            accessibilityLabel: 'All operations',
            panelID: 'all-operations-content-1',
        },
        {
            id: 'product-operations',
            content: 'Product operations',
            accessibilityLabel: 'Product operations',
            panelID: 'product-operations-content-1',
        },
        {
            id: 'customer-operations',
            content: 'Customer operations',
            accessibilityLabel: 'Customer operations',
            panelID: 'customer-operations-content-1',
        },
        {
            id: 'automated-operations',
            content: 'With Automations',
            panelID: 'operations-with-automations-content-1',
        },
    ];

    const navigateTo = (url) => {
        history.push(url);
    }

    return (
        <div>
            <Helmet>
                <title>Tag Genie - Bulk Tag Operations</title>
            </Helmet>
            <Page
                title="Bulk Operations"
                primaryAction={{ content: 'Create Bulk Tag Operation', onAction: () => { navigateTo("/operations/new") } }}>
                <Layout>
                    <Layout.Section>
                        <Card>
                            <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
                                <Card.Section>
                                    <React.Fragment>
                                        {filterControl}
                                        <ResourceList
                                            resourceName={{ singular: 'operation', plural: 'operations' }}
                                            items={items}
                                            renderItem={renderOperationItem}
                                            sortValue={sortValue}
                                            sortOptions={[
                                                { label: 'Newest', value: 'DATE_MODIFIED_DESC' },
                                                { label: 'Oldest', value: 'DATE_MODIFIED_ASC' },
                                            ]}
                                            onSortChange={(selected) => {
                                                setSortValue(selected);
                                            }}
                                        />
                                    </React.Fragment>
                                    {/* {tabs[selected].content} */}
                                </Card.Section>
                            </Tabs>
                        </Card>
                    </Layout.Section>
                </Layout>
            </Page>
        </div >
    );

    function renderOperationItem(item) {
        const { id, description, name, status } = item;

        return (
            <ResourceItem id={id} url={null} onClick={(e) => handleItemClick(e, item)}>
                <Stack alignment="center" distribution="leading" wrap={false}>
                    <Stack.Item fill>
                        <TextStyle variation="strong">{name || description}</TextStyle>
                    </Stack.Item>
                    <Stack.Item>
                        {status === "Completed" && <div>
                            <Badge status="success">Completed</Badge>
                        </div>}
                        {status === "Running" && <div>
                            <Badge status="attention">Running</Badge>
                        </div>}
                        {status === "NotExecuted" && <div>
                            <Badge status="info">Not executed</Badge>
                        </div>}
                    </Stack.Item>
                </Stack>
            </ResourceItem>
        );
    }

    function handleItemClick(e, item) {

        if (item.operationType == null || item.operationType === "Legacy") {
            if (item.type === "Customer") {
                // history.push(`/operations/customer/${item.id}/edit/`);
                history.push(`/operations/customer/${item.id}`);
            }
            else {
                history.push(`/operations/${item.id}`);
            }
        }
        else {
            history.push(`/bulk-operations/${item.id}`);
        }
    }

    function getFilterControl() {

        const filters = [];
        const appliedFilters = !isEmpty(operationFilterValue)
            ? [
                {
                    key: 'operationDescriptionFilter',
                    label: disambiguateLabel('operationDescriptionFilter', operationFilterValue),
                    onRemove: handleOperationFilterRemove,
                },
            ]
            : [];

        return <Filters
            focused={true}
            queryValue={queryValueValue}
            queryPlaceholder="Filter operations by description"
            filters={filters}
            appliedFilters={appliedFilters}
            onQueryChange={setQueryValueValue}
            onQueryClear={() => { setQueryValueValue(null) }}
            onQueryBlur={() => { }}
            onClearAll={handleClearAll} >
        </Filters>
    }

    function handleClearAll() {
        setQueryValueValue(null);
        setOperationFilterValue(null);
    }

    function handleOperationFilterRemove() {
        setOperationFilterValue(null);
    }
}

export default OperationsIndex;